import { DataService, UtilityService } from "../../../../shared/session/index";
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { SessionInfo } from "../../../../shared/session/SessionInfo";
import { Iaccess } from './../shared/access.model';

@Injectable()
export class AccessService {
  constructor(private dataService: DataService, private utilityService: UtilityService, private sessionInfo: SessionInfo) { }
  private insertarAccessUrl: string = 'access/insertar';
  private actualizarAccessUrl: string = 'access/actualizar';
  private obtenerAccessUrl: string = 'access/obtener';
  private listarAccessUrl: string = 'access/listar';
  private listarPorAccessUrl: string = 'access/listarPor';
  private listarAccessPorRolUrl: string = 'access/listarPorRole'
  private asignarRolAccessUrl: string = 'roleAccess/insertar'
  private deleteRolAccessUrl: string = 'roleAccess/delete'
  private listarAccesoSubmoduloUrl: string = 'access/listarAccesoSubmodulo';
  private listarPorAccesoUrl: string = 'access/listarPorAcceso';

  toggleRolAccess(RoleID: number, AplicacionID: number, OfficeID: number, AccessID: number, identificador: boolean) {
    let parameters: string;
    parameters = JSON.stringify({
      RoleID: RoleID,
      AplicacionID: AplicacionID,
      OfficeID: OfficeID,
      AccessID: AccessID,
    })
    if (identificador)
      this.dataService.set(this.asignarRolAccessUrl);
    else
      this.dataService.set(this.deleteRolAccessUrl);

    return this.dataService.execPostJson(parameters);
  }

  listarPorRole(RoleID: number, filtro: string): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pRoleID", String(RoleID));
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("idNivelAcceso", String(this.sessionInfo.getIdNivelAcceso()));
    parameters = parameters.append("idEntidad", String(this.sessionInfo.getIdEntidad()));
    this.dataService.set(this.listarAccessPorRolUrl);
    return this.dataService.execGetJson(parameters);
  }

  listarPorAccess(filtro: string, pAplicacionID: number, pModuleID: number, pageIndex: number, pageSize: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", filtro);
    parameters = parameters.append("pAplicacionID", String(pAplicacionID));
    parameters = parameters.append("pModuleID", String(pModuleID));
    this.dataService.set(this.listarPorAccessUrl);
    return this.dataService.execGetJson(parameters);
  }

  obtenerAccess(accessID: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pKey", String(accessID));
    this.dataService.set(this.obtenerAccessUrl);
    return this.dataService.execGetJson(parameters);
  }

  insertarAccess(access: Iaccess): any {
    let parameters: string;
    parameters = JSON.stringify({
      Path: access.Path,
      Icono: access.Icono,
      Name: access.Name,
      Description: access.Description,
      Status: access.Status,
      AplicacionID: access.AplicacionID,
      ModuleID: access.ModuleID
    });

    this.dataService.set(this.insertarAccessUrl);
    return this.dataService.execPostJson(parameters);
  }

  actualizarAccess(access: Iaccess): any {
    let parameters: string;
    parameters = JSON.stringify({
      ID: String(access.ID),
      Path: access.Path,
      Name: access.Name,
      Description: access.Description,
      Status: access.Status,
      ModuleID: access.ModuleID,
      userlastupdate: this.sessionInfo.getCodUsuario(),
      AplicacionID: String(access.AplicacionID)
    });

    this.dataService.set(this.actualizarAccessUrl);
    return this.dataService.execPostJson(parameters);
  }

  listarAccesoSubmodulo(filtro: string, idAplicacion: number, idNivelAcceso: number, idEntidad: number, idRol: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("idAplicacion", String(idAplicacion));
    parameters = parameters.append("idNivelAcceso", String(idNivelAcceso));
    parameters = parameters.append("idEntidad", String(idEntidad));
    parameters = parameters.append("idRol", String(idRol));
    this.dataService.set(this.listarAccesoSubmoduloUrl);
    return this.dataService.execGetJson(parameters);
  }

  listarPorAcceso(idUsuario: number, idAplicacion: number, idNivelAcceso: number, idEntidad: number, idRol: number, idModule: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("idUsuario", String(idUsuario));
    parameters = parameters.append("idAplicacion", String(idAplicacion));
    parameters = parameters.append("idNivelAcceso", String(idNivelAcceso));
    parameters = parameters.append("idEntidad", String(idEntidad));
    parameters = parameters.append("idRol", String(idRol));
    parameters = parameters.append("idModule", String(idModule));
    this.dataService.set(this.listarPorAccesoUrl);
    return this.dataService.execGetJson(parameters);
  }
}